export const START_WORKFLOW_INSTANCE = `
mutation startWorkflowInstance($input: StartWorkflowInstanceInput!) {
startWorkflowInstance(input: $input) {
__typename
... on FlowInstance {
    id
}
    }
}`;

export const COMPLETE_TASK = `
mutation completeTask($input: CompleteTaskInput!) {
  completeTask(input: $input) {
    __typename
    ... on WorkflowOperationResponse {
      message
    }
    ... on ResultError {
      status_code
      message
    }
  }
}`;

export const ADD_COMMENT_TO_TASK = `
mutation addCommentToTask($input: AddCommentToTaskInput!) {
  addCommentToTask(input: $input) {
    __typename
    ... on WorkflowOperationResponse {
      message
    }
    ... on ResultError {
      status_code
      message
    }
  }
}
`;

export const SET_DUEDATE_TO_TASK = `
mutation setDueDateToTask($input: SetDueDateToTaskInput!) {
  setDueDateToTask(input: $input) {
    __typename
    ... on WorkflowOperationResponse {
      message
    }
    ... on ResultError {
      status_code
      message
    }
  }
}`;

export const UPLOAD_WORKFLOW_FILES = `
mutation uploadWorkflowFiles(
  $files:  [Upload!]!,
  $input: UploadWorkflowFilesInput!
){
  uploadWorkflowFiles(
      files: $files,
      input: $input
    ){
      __typename
      ... on WorkflowOperationResponse {
        message
      }
      ... on ResultError {
        status_code
        message
      }
    }
  }
`;
